import { isKharonV2Allowed } from '@retracedgmbh/modules';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';
import { PLATFORM_FEATURES } from '@/lib/constants/features';
import { hasFeature } from '@/lib/utils/features';
import { bootstrapSession } from '@/lib/utils/session';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute('/(client)/entity-screening')({
  beforeLoad: async () => {
    const user = useSessionStore.getState().user ?? (await bootstrapSession());
    if (!hasFeature(user, PLATFORM_FEATURES.ENTITY_SCREENING_V2)) {
      throw redirect({ to: '/dashboard' });
    }

    if (!isKharonV2Allowed(user?.companyId, user?.id)) {
      throw redirect({ to: '/dashboard' });
    }

    const perms = await ensurePermissions();
    if (!perms['entity-screening'].canRead) {
      throw redirect({ to: '/dashboard' });
    }
  },
});
